import styled, { keyframes, css } from "styled-components";
import { colors, types } from "../../../libs";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(-16px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-16px); }
`;

export const Overlay = styled.div<{ $closing: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: ${({ $closing }) => css`${$closing ? fadeOut : fadeIn} 0.2s ease forwards`};
`;

export const Modal = styled.div<{ $closing: boolean }>`
  background: ${colors.background.lightBlack};
  border-radius: 12px;
  padding: 24px;
  width: 700px;
  max-width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  animation: ${({ $closing }) => css`${$closing ? slideOut : slideIn} 0.2s ease forwards`};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  ${types.body.normal};
  font-weight: bold;
  color: ${colors.text.white};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${colors.text.gray};
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    color: ${colors.text.white};
  }
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
`;

export const MetaBadge = styled.div`
  background: ${colors.background.lightGrey};
  border-radius: 6px;
  padding: 6px 12px;
  ${types.body.small};
  color: ${colors.text.gray};

  span {
    color: ${colors.text.white};
    font-weight: 600;
    margin-left: 4px;
  }
`;

export const CodeBlock = styled.pre`
  background: #0d0d0d;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 16px;
  color: #a8ff78;
  font-family: "Courier New", monospace;
  font-size: 13px;
  overflow-x: auto;
  white-space: pre;
  margin: 0;
`;

export const CopyRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${colors.background.lightGrey};
  border: none;
  border-radius: 6px;
  color: ${colors.text.white};
  cursor: pointer;
  padding: 8px 14px;
  ${types.body.small};

  &:hover {
    background: ${colors.background.greyWhite};
  }
`;
